/* @flow */

/**
 * Load Intl API's polyfills
 * @returns {Promise} Promise
 */
export function polyfillIntl(): Promise<void> {
  // $FlowIssue: ?
  return Promise.all([
    polyfillIntlPluralRules(),
    polyfillIntlRelativeTimeFormat(),
    polyFillIntlGetCanonicalLocales(),
  ]);
}

/**
 * Load a polyfill for plural rules if necessary. If a polyfill is not required
 * the promise resolves instantly.
 *
 * Ref: https://formatjs.io/docs/react-intl/
 * @returns {Promise} Promise
 */
export function polyfillIntlPluralRules(): Promise<void> {
  return new Promise((resolve, reject) => {
    if ('PluralRules' in Intl) {
      resolve();
    } else {
      Promise.all([
        import('@formatjs/intl-pluralrules/polyfill'),
        import('@formatjs/intl-pluralrules/locale-data/en'),
        import('@formatjs/intl-pluralrules/locale-data/fr'),
      ])
        .then(() => resolve())
        .catch(() => reject());
    }
  });
}

/**
 * Load a polyfill for relative time format if necessary. If a polyfill is not
 * required, the promise resolves instantly.
 *
 * Ref: https://formatjs.io/docs/react-intl/
 * @returns {Promise} Promise
 */
export function polyfillIntlRelativeTimeFormat(): Promise<void> {
  return new Promise((resolve, reject) => {
    if ('RelativeTimeFormat' in Intl) {
      resolve();
    } else {
      Promise.all([
        import('@formatjs/intl-relativetimeformat/polyfill'),
        import('@formatjs/intl-relativetimeformat/locale-data/en'),
        import('@formatjs/intl-relativetimeformat/locale-data/fr'),
      ])
        .then(() => resolve())
        .catch(() => reject());
    }
  });
}

/**
 * Load a polyfill for canonical locales if necessary. If a polyfill is not
 * required, the promise resolves instantly.
 *
 * Ref: https://formatjs.io/docs/react-intl/
 * @returns {Promise} Promise
 */
export function polyFillIntlGetCanonicalLocales(): Promise<void> {
  return new Promise((resolve, reject) => {
    if ('getCanonicalLocales' in Intl) {
      resolve();
    } else {
      Promise.all([import('@formatjs/intl-getcanonicallocales/polyfill')])
        .then(() => resolve())
        .catch(() => reject());
    }
  });
}
